import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;
const idFlowGetData = process.env.REACT_APP_ID_FLOW_GET_DATA_COMPLETE_DIGITAL_SIGNATURE;

export const fetchDocumentToSign = (token) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': 'Basic OTAwMTE0MDk4OlplMW1HTnVkOGNYd2lYa0dHODd6RlNTYU5zWTJJZ0Nt'
        },
        data: JSON.stringify({
            "id_flow": idFlowGetData,
            "id": token
        })
    })
}

export const SaveSingAndData = (obj) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': 'Basic OTAwMTE0MDk4OlplMW1HTnVkOGNYd2lYa0dHODd6RlNTYU5zWTJJZ0Nt'
        },
        data: JSON.stringify(obj)
    })
}